import { API } from '../api'
import { RejectParams } from './interface'

export const patch = async (
  filtros: Record<string, any>
): Promise<{
  conteudo: string
  sucesso: boolean
}> => {
  try {
    const { collectId, ...filtrosRest } = filtros
    const response = await API.patch<RejectParams>(
      `/logistica/item/recusar-itens?idAgrupamento=${collectId}`,
      filtrosRest
    )

    return {
      conteudo: response?.content,
      sucesso: response?.isSuccess
    }
  } catch (error) {
    console.error('Erro ao solicitar justificativa:', error)
    return {
      conteudo: null,
      sucesso: false
    }
  }
}
